'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _genericMaterialDefaults = require('../../../lib/genericMaterialDefaults');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = _antd.Select.Option;

var TemplateSelect = function (_Component) {
	_inherits(TemplateSelect, _Component);

	function TemplateSelect(props) {
		_classCallCheck(this, TemplateSelect);

		var _this = _possibleConstructorReturn(this, (TemplateSelect.__proto__ || Object.getPrototypeOf(TemplateSelect)).call(this, props));

		_this.state = {
			selectedTemplate: undefined
		};
		return _this;
	}

	_createClass(TemplateSelect, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
				_react2.default.createElement(
					'span',
					{ style: { marginRight: 20, fontSize: 18 } },
					'Escolher template'
				),
				_react2.default.createElement(
					_antd.Select,
					{
						value: this.state.selectedTemplate,
						style: { width: 200 },
						placeholder: 'Selecionar um template',
						onChange: function onChange(value) {
							_this2.setState({
								selectedTemplate: value
							});
						}
					},
					_react2.default.createElement(
						Option,
						{ value: 'OABfirstPhaseTemplate' },
						'OAB - Disciplinas 1\xBA Fase'
					),
					_react2.default.createElement(
						Option,
						{ value: 'OABsecondPhaseTemplate' },
						'OAB - Disciplinas 2\xBA Fase'
					),
					_react2.default.createElement(
						Option,
						{ value: 'emptyTemplate' },
						'Deletar Lista Atual'
					)
				),
				_react2.default.createElement(
					_antd.Button,
					{
						style: { marginLeft: 20 },
						type: 'primary',
						onClick: function onClick() {
							var selectedTemplate = _this2.state.selectedTemplate;
							var gData = _this2.props.gData;


							if (selectedTemplate !== '') {
								if (gData.length > 0) {
									_antd.Modal.confirm({
										title: 'Atenção',
										content: 'Todo o conteúdo abaixo será excluido, deseja continuar?',
										onOk: function onOk() {
											_this2.props.changeTemplate(_lodash2.default.cloneDeep(_genericMaterialDefaults.templates[selectedTemplate]));
											_this2.setState({
												selectedTemplate: ''
											});
											return Promise.resolve();
										},
										onCancel: function onCancel() {
											_this2.setState({ selectedTemplate: '' });
											return Promise.resolve();
										}
									});
								} else {
									_this2.props.changeTemplate(_lodash2.default.cloneDeep(_genericMaterialDefaults.templates[selectedTemplate]));
									_this2.setState({
										selectedTemplate: ''
									});
								}
							}
						}
					},
					'OK'
				)
			);
		}
	}]);

	return TemplateSelect;
}(_react.Component);

exports.default = TemplateSelect;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/ContentTree/TemplateSelect.js
// module id = 3235
// module chunks = 0